import { useRef, useState } from 'react';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { Trans } from '@lingui/react/macro';
import api, { parseErrors } from 'util/api';
import { Banner } from '@thermon-platforms/thermon-ui-core';
import { isNumber } from 'lodash';


function ParametersModal({ action, device, dismiss, close }) {
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);
  const parameters = useRef({});

  function doAction() {
    setLoading(true);
    setErrors(undefined);

    api(`/devices/${device.id}${action.url}`, {
      method: action.method,
      body: JSON.stringify(parameters.current),
    })
    .then(() => {
      close();
    })
    .catch(async res => {
      setErrors(parseErrors(await res.json()));
    })
    .finally(() => {
      setLoading(false);
    });
  }

  return (
    <I18nProvider i18n={i18n}>
      <header><h3>{action.name}</h3></header>
      <section>
        <Banner status="alert" show={errors}>
          <Trans>An error occurred attempting to perform this action. Please, try again.</Trans>
        </Banner>
        <ul className="form">
          {action.parameters.map((parameter, index) => (
            <li key={`parameter-${index}`}>
              <label htmlFor={`parameter-${index}`}>{parameter.name}</label>
              <input
                type={parameter.type || 'text'}
                className={errors?.[parameter?.name] ? 'error' : ''}
                name={`parameter-${index}`}
                id={`parameter-${index}`}
                {...(parameter.type == 'number' ? { max: parameter.max, min: parameter.min } : {})}
                defaultValue={parameter.defaultValue || ''}
                onChange={e => {
                  const val = e.target.value;
                  if (parameter.type == 'number' && isNumber(parameter.max)) {
                    if (val > parameter.max) {
                      e.target.value = parameter.max;
                      return;
                    }
                  }
                  if (parameter.type == 'number' && isNumber(parameter.min)) {
                    if (val < parameter.min) {
                      e.target.value = parameter.min;
                      return;
                    }
                  }
                  parameters.current[parameter.name] = val;
                }}
              />
              {errors?.[parameter.name] && (
                <p className="error-text">{errors[parameter.name]}</p>
              )}
            </li>
          ))}
        </ul>
      </section>
      <footer>
        <button onClick={dismiss}><Trans>Cancel</Trans></button>
        <button
          className={`primary ${loading ? 'processing' : ''}`}
          onClick={doAction}
          disabled={loading}
        >
          <Trans>Run</Trans>
        </button>
      </footer>
    </I18nProvider>
  );
}

export default ParametersModal;
